import {keys} from 'ts-transformer-keys';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type MailServer = {
    id : number;
    key : string;
    name : string;

    /** the hostname or IP address to connect to */
    hostname: string;
    /** the port to connect to (defaults to 25 or 465) */
    port: string;
    /** the username */
    username?: string;
    /** the password */
    password?: string;
    /** defines if the connection should use SSL (if true) or not (if false) */
    secure?: boolean;
    /** turns off STARTTLS support if true */
    ignoreTLS?: boolean;
    /** forces the client to use STARTTLS. Returns an error if upgrading the connection is not possible or fails. */
    requireTLS?: boolean;
    /** tries to use STARTTLS and continues normally if it fails */
    opportunisticTLS?: boolean;
    /** how many milliseconds to wait for the connection to establish */
    connectionTimeout: number;
    /** how many milliseconds to wait for the greeting after connection is established */
    greetingTimeout: number;
    /** how many milliseconds of inactivity to allow */
    socketTimeout: number;
};
export const mailServerProps = keys<MailServer>();
export const requiredMailServerProps = keys<RequiredOf<MailServer>>();
